export class LoanCicHistoryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCicHistory({ loanId }) {
    return this.#http.get(`/loan/${loanId}/cic-history`);
  }

  async editCicChange({ loanId, changeId, cicReasonId, comment }) {
    return this.#http.put(`/loan/${loanId}/cic-history/changes/${changeId}`, {
      cicReasonId,
      comment,
    });
  }

  async editCicFeeChange({ loanId, feeChangeId, cicReasonId, comment }) {
    return this.#http.put(`/loan/${loanId}/cic-history/fee-changes/${feeChangeId}`, {
      cicReasonId,
      comment,
    });
  }
}
